import { lazy } from 'react'

import logo from './assets/logo.svg'

const dispatchersModule = {
  meta: {
    logo,
    name: 'dispatchers',
    title: 'Despachantes',
    path: '/dispatchers/dashboard'
  },
  routes: [
    {
      name: 'Dashboard',
      path: '/dispatchers/dashboard',
      exact: true,
      component: lazy(() => import('./pages/Dashboard')),
      meta: {
        isPrivate: true,
        permissions: ['dispatcher_dashboard:show']
      }
    },
    {
      name: 'Customers',
      path: '/dispatchers/customers',
      exact: true,
      component: lazy(() => import('./pages/Customers')),
      meta: {
        isPrivate: true,
        permissions: ['dispatcher_customers:list']
      }
    },
    {
      name: 'NewCustomer',
      path: '/dispatchers/customers/new',
      exact: true,
      component: lazy(() => import('./pages/CustomerForm')),
      meta: {
        isPrivate: true,
        permissions: ['dispatcher_customers:create']
      }
    },
    {
      name: 'CustomerDetails',
      path: '/dispatchers/customers/:id',
      exact: true,
      component: lazy(() => import('./pages/CustomerDetails')),
      meta: {
        isPrivate: true,
        permissions: ['dispatcher_customers:show']
      }
    },
    {
      name: 'EditCustomer',
      path: '/dispatchers/customers/:id/edit',
      exact: true,
      component: lazy(() => import('./pages/CustomerForm')),
      meta: {
        isPrivate: true,
        permissions: ['dispatcher_customers:edit']
      }
    },
    {
      name: 'Sales',
      path: '/dispatchers/sales',
      exact: true,
      component: lazy(() => import('./pages/Sales')),
      meta: {
        isPrivate: true,
        permissions: ['dispatcher_sales:list']
      }
    },
    {
      name: 'NewSale',
      path: '/dispatchers/sales/new',
      exact: true,
      component: lazy(() => import('./pages/SaleForm')),
      meta: {
        isPrivate: true,
        permissions: ['dispatcher_sales:create']
      }
    },
    {
      name: 'BudgetList',
      path: '/dispatchers/budgets',
      exact: true,
      component: lazy(() => import('./pages/Budgets')),
      meta: {
        isPrivate: true,
        permissions: ['dispatcher_budgets:create']
      }
    },
    {
      name: 'NewBudget',
      path: '/dispatchers/budgets/new',
      exact: true,
      component: lazy(() => import('./pages/BudgetForm')),
      meta: {
        isPrivate: true,
        permissions: ['dispatcher_budgets:create']
      }
    },
    {
      name: 'BudgetDetails',
      path: '/dispatchers/budgets/:id',
      exact: true,
      component: lazy(() => import('./pages/BudgetForm')),
      meta: {
        isPrivate: true,
        permissions: ['dispatcher_budgets:show']
      }
    },
    {
      name: 'BudgetInvoice',
      path: '/dispatchers/budgets/:id/invoice',
      exact: true,
      component: lazy(() => import('./pages/BudgetInvoice')),
      meta: {
        isPrivate: true,
        permissions: ['dispatcher_budgets:show']
      }
    },
    {
      name: 'EditSale',
      path: '/dispatchers/sales/:id/edit',
      exact: true,
      component: lazy(() => import('./pages/SaleForm')),
      meta: {
        isPrivate: true,
        permissions: ['dispatcher_sales:edit']
      }
    },
    {
      name: 'SaleDetails',
      path: '/dispatchers/sales/:id',
      exact: true,
      component: lazy(() => import('./pages/SaleDetails')),
      meta: {
        isPrivate: true,
        permissions: ['dispatcher_sales:show']
      }
    },
    {
      name: 'SaleDetails',
      path: '/dispatchers/sales/:id/invoice',
      exact: true,
      component: lazy(() => import('./pages/SaleInvoice')),
      meta: {
        isPrivate: true,
        permissions: ['dispatcher_sales:show']
      }
    },
    {
      name: 'Vehicles',
      path: '/dispatchers/vehicles',
      exact: true,
      component: lazy(() => import('./pages/Vehicles')),
      meta: {
        isPrivate: true,
        permissions: ['dispatcher_vehicles:list']
      }
    },
    {
      name: 'SaleStages',
      path: '/dispatchers/sale/stages',
      exact: true,
      component: lazy(() => import('./pages/SaleStages')),
      meta: {
        isPrivate: true,
        permissions: ['dispatcher_sale-stages:list']
      }
    },
    {
      name: 'ServiceTypes',
      path: '/dispatchers/services/types',
      exact: true,
      component: lazy(() => import('./pages/ServiceTypes')),
      meta: {
        isPrivate: true,
        permissions: ['dispatcher_service-types:list']
      }
    }
  ]
}

export default dispatchersModule
